import api from '.';

export const parametroByEmpresaId = async (empresaId) => {
    if (!empresaId) {
        return;
    }
    try {
        const { data } = await api.get('/parametro/parametroByEmpresaId', {
            params: { empresaId },
        });
        return data;
    } catch (error) {
        return error;
    }
};
//ainda não criado no backend
export const parametroOperacaoCustoByParametroId = async (parametroId) => {
    if (!parametroId) {
        return;
    }
    try {
        const { data } = await api.get('/parametro/parametroOperacaoCustosByParametroId', {
            params: { parametroId },
        });
        return data;
    } catch (error) {
        return error;
    }
};
export const listarOperacoesCustos = async ({ start, size, filters, filtersMode, globalFilter, sorting, parametroId }) => {
    try {
        const data = await api.get('/parametro/listarOperacoesCustos/', {
            params: { start, size, filters, filtersMode, globalFilter, sorting, parametroId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const duplicidadeOperacaoCusto = async ({ parametroId, operacaoId, plantaoTipoId, uuid }) => {
    try {
        const { data } = await api.get('/parametro/duplicidadeOperacaoCusto/', {
            params: { parametroId, operacaoId, plantaoTipoId, uuid },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const CreateOrEditOperacaoCusto = async (objeto) => api.post(`parametro/createOrEditOperacaoCusto`, objeto);
export const deletarOperacaoCusto = (uuid) => api.post('/parametro/deletarOperacaoCusto', { uuid });

export const managerExpediente = async (objeto) => api.post(`parametro/managerExpediente`, objeto);
export const listarExpediente = async ({ start, size, filters, filtersMode, globalFilter, sorting, parametroId }) => {
    try {
        const data = await api.get('/parametro/listarExpediente/', {
            params: { start, size, filters, filtersMode, globalFilter, sorting, parametroId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
